import { render, staticRenderFns } from "./ApPrepayments.vue?vue&type=template&id=ed96c352&scoped=true&"
import script from "./ApPrepayments.vue?vue&type=script&lang=ts&"
export * from "./ApPrepayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96c352",
  null
  
)

export default component.exports